export enum TOKEN_STANDARD {
  EXT = "EXT",
  DIP20 = "DIP20",
  ICP = "ICP",
  DIP20_WICP = "DIP20-WICP",
  DIP20_XTC = "DIP20-XTC",
  ICRC1 = "ICRC1",
  ICRC2 = "ICRC2",
}
